import { render, staticRenderFns } from "./ArrivedOrderPage.vue?vue&type=template&id=084f697b&scoped=true&"
import script from "./ArrivedOrderPage.vue?vue&type=script&lang=js&"
export * from "./ArrivedOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f697b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084f697b')) {
      api.createRecord('084f697b', component.options)
    } else {
      api.reload('084f697b', component.options)
    }
    module.hot.accept("./ArrivedOrderPage.vue?vue&type=template&id=084f697b&scoped=true&", function () {
      api.rerender('084f697b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/View/ArrivedOrderPage.vue"
export default component.exports